import { getZuuModeSwitchLabels } from "./components/zuu/zuuPresentation.js";

export type CustomerNavKey =
  | "fna"
  | "profile"
  | "insured"
  | "beneficiary"
  | "history";

export type CustomerDetailSectionMode =
  | "original"
  | "zuu-dashboard"
  | "shared-profile"
  | "shared-insured"
  | "shared-beneficiary"
  | "shared-history";

export function getCustomerDetailSectionMode(
  isZuuMode: boolean,
  activeNav: CustomerNavKey,
): CustomerDetailSectionMode {
  if (!isZuuMode) return "original";

  switch (activeNav) {
    case "fna":
      return "zuu-dashboard";
    case "profile":
      return "shared-profile";
    case "insured":
      return "shared-insured";
    case "beneficiary":
      return "shared-beneficiary";
    case "history":
      return "shared-history";
    default:
      return "original";
  }
}

export function getZuuModeSwitchCopy(isZuuMode: boolean) {
  return getZuuModeSwitchLabels(isZuuMode ? "zuu" : "original");
}
